<!--  -->
<template>
  <div class="record-page section-main__warp">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleDetail(scope.row)"
          ></el-button>
        </el-tooltip>
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="结束"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-shanchu"
            @click="handleStop(scope.row, scope.index)"
          ></el-button>
        </el-tooltip> -->
      </template>
      <!-- <template slot="status">
        <el-select v-model="status">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
      </template> -->
    </ioc-table>
    <app-panel
      :isExpand="showDetail"
      title="任务详情"
      @cancel="handleClosePanel"
    >
      <div class="detail-main">
        <el-scrollbar style="height: 100%">
          <div class="base-body">
            <div class="base-title">基本信息</div>
            <div class="base-table">
              <div class="base-table_row">
                <div class="col-content">
                  <div class="col-label">任务单号：</div>
                  <div class="col-value">
                    {{ taskDetailTable.taskCode || "无" }}
                  </div>
                </div>
                <div class="col-content">
                  <div class="col-label">任务名称：</div>
                  <div class="col-value">
                    {{ taskDetailTable.taskName || "无" }}
                  </div>
                </div>
                <!-- <div class="col-content">
                <div class="col-label">任务状态：</div>
                <div class="col-value">
                  {{ taskStatusList[taskDetailTable.taskStatus - 1] || "无" }}
                </div>
              </div> -->
              </div>

              <div class="base-table_row">
                <div class="col-content">
                  <div class="col-label">责任人：</div>
                  <div class="col-value">
                    {{ taskDetailTable.processorName || "无" }}
                  </div>
                </div>
                <div class="col-content">
                  <div class="col-label">执行人员：</div>
                  <div class="col-value">
                    {{ taskDetailTable.processorName || "无" }}
                  </div>
                </div>
              </div>
              <div class="base-table_row">
                <div class="col-content">
                  <div class="col-label">开始时间：</div>
                  <div class="col-value">
                    {{ taskDetailTable.startTime | formatDate }}
                  </div>
                </div>
                <div class="col-content">
                  <div class="col-label">完成时间：</div>
                  <div class="col-value">
                    {{ taskDetailTable.endTime | formatDate }}
                  </div>
                </div>
              </div>
              <div class="base-table_row">
                <div class="col-content">
                  <div class="col-label">发现问题：</div>
                  <div class="col-value">
                    {{
                      taskDetailTable.videoPatrolAlarms &&
                      taskDetailTable.videoPatrolAlarms.length > 0
                        ? "是"
                        : "否"
                    }}
                  </div>
                </div>
              </div>
              <div class="base-table_row">
                <div class="col-content">
                  <div class="col-label">打卡结果：</div>
                  <div>
                    应打卡{{ taskDetailTable.signCount }}个，实际打卡{{
                      taskDetailTable.realSignCount
                    }}个，漏打卡{{
                      taskDetailTable.signCount - taskDetailTable.realSignCount
                    }}个
                  </div>
                </div>
              </div>
              <div class="base-table_row">
                <div class="col-content">
                  <div class="col-label">报告备注：</div>
                  <div>
                    {{ taskDetailTable.reportDesc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="question-body">
            <div class="question-title">问题详情</div>
            <ioc-table
              :option="questionOptions"
              :data="taskDetailTable.videoPatrolAlarms"
            >
              <template slot="questionDetail" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    icon="iconfont icon-Detail"
                    @click="handleQuestionDetail(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </el-scrollbar>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel"> 关闭</el-button>
      </div>
    </app-panel>
    <app-panel
      :isExpand="showQuestionDetail"
      @cancel="handleCloseQuestionP"
      title="巡逻问题详情"
    >
      <div class="base-table">
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">上报时间：</div>
            <div class="col-value">
              {{ questionDetail.reportTime || "无" }}
            </div>
          </div>
          <div class="col-content">
            <div class="col-label">上报人：</div>
            <div class="col-value">
              {{ questionDetail.reportPersonName || "无" }}
            </div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">事件编号：</div>
            <div class="col-value">{{ questionDetail.alarmId || "无" }}</div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">问题描述：</div>
            <div class="col-value">
              {{ questionDetail.desc || "无" }}
            </div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">现场图片：</div>
            <div class="ioc-detail__image" style="width: 90%; margin: 10px 0">
              <template v-if="questionDetail.picUrl">
                <el-carousel style="height: 180px; overflow: hidden">
                  <el-carousel-item
                    v-for="item in (questionDetail.picUrl || '无').split(',')"
                    :key="item"
                  >
                    <img
                      class="lookPhoto"
                      :src="getImgPath(item)"
                      style="margin-left: 160px; width: 300px; height: 180px"
                      alt
                      @click="showViewer"
                      onerror="this.src='/images/theme/newDark/default.png'"
                    />
                  </el-carousel-item>
                </el-carousel>
              </template>
              <template v-else>
                <img :src="`/images/theme/newDark/default.png`" />
              </template>
            </div>
          </div>
        </div>
        <div class="base-table_row">
          <div class="col-content">
            <div class="col-label">录像回放：</div>
            <div class="col-value">
              <video
                v-if="questionDetail.videoUrl"
                class="file-comp"
                :src="$utils.Bus.imgPath(questionDetail.videoUrl)"
              ></video>
              <div>无</div>
              <!-- <video preload="none" id="videoDom" controls="controls">
                您的浏览器不支持 video 标签。
              </video> -->
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="close" type="info" class="buttonDark"
          >关闭</el-button
        >
      </div>
    </app-panel>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import { formatTimeToStr } from "../filter/dateUtils";
import tableOption from "../config/recordOption";
import utils from "@src/common/utils";
import { Base, Bus, Cache } from "$utils";
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    appPanel,
  },
  filters: {
    formatDate: function (time) {
      if (time !== null && time !== "") {
        return formatTimeToStr(new Date(time));
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      viewerPhotos: [],
      viewerInstance: null,
      Bus,
      tableData: [],
      option: tableOption(this),
      status: "",
      statusList: [
        { label: "全部状态", value: 0 },
        { label: "未开始", value: 1 },
        { label: "执行中", value: 2 },
        { label: "已完成", value: 3 },
      ],
      questionOptions: {
        emptyText: "暂无数据",
        indexLabel: "序号",
        index: true,
        column: [
          {
            label: "上报人",
            prop: "reportPerson",
            span: 12,
            align: "center",
          },
          {
            label: "上报时间",
            prop: "reportTime",
            // search: true,
            span: 12,
            align: "center",
          },
          {
            label: "问题详情",
            prop: "questionDetail",
            formSlot: true,
          },
        ],
      },
      page: {
        pageNo: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        //  total: 0,
      },
      showDetail: false,
      showQuestionDetail: false,
      formData: {},
      taskDetailTable: {},
      searchForm: {},
      taskStatusList: ["未开始", "执行中", "已完成"],
      questionDetail: {},
    };
  },
  mounted() {
    this.queryRecordList();
  },
  methods: {
    showViewer(e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    // 1.图片放大器
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    // 查看大图
    pictureShow(val) {
      this.viewerPhotos = [val];
      this.viewerInstance.show();
    },
    getImgPath(item = "") {
      return item ? Bus.imgPath(item) : "";
    },
    //巡逻记录
    queryRecordList() {
      let params = {
        taskName: this.searchForm.taskName,
        processorName: this.searchForm.processorName,
        taskStatus: this.searchForm.taskStatus,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        startTime: this.searchForm.dateRange
          ? this.searchForm.dateRange[0]
          : "",
        endTime: this.searchForm.dateRange ? this.searchForm.dateRange[1] : "",
      };
      this.$fetch(api.videoTask.queryHisJobs, params).then((res) => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          // console.log(this.tableData, "===tableData ");
          this.page.total = res.returnObj.total;
        }
      });
    },
    handleSearchChange(form) {
      // console.log(form, "===form");
      this.searchForm = form;
      // let formData = {};
      // if (form.dateRange) {
      //   formData.startTime = form.dateRange[0];
      //   formData.endTime = form.dateRange[1];
      // }

      // formData = form;
      // delete formData.dateRange;
      // formData.taskName = form.taskName;
      // formData.processorName = form.processorName;
      this.queryRecordList();
    },
    handleSearchReset() {
      this.queryRecordList();
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.queryRecordList();
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo;
      this.queryRecordList();
    },
    handleDetail(data) {
      this.showDetail = true;
      this.$fetch(api.videoTask.historyJobInfo, {
        taskCode: data.code,
      }).then((res) => {
        this.taskDetailTable = res.returnObj;
        //   this.taskDetailTable.miss =
        //     this.taskDetailTable != null && this.taskDetailTable.signCount != null
        //       ? this.taskDetailTable.signCount
        //       : 0 - this.taskDetailTable != null &&
        //         this.taskDetailTable.realSignCount != null
        //       ? this.taskDetailTable.realSignCount
        //       : 0;
      });
      // this.taskDetailTable = data;
    },
    handleStop() {
      this.$confirm("任务结束后不可再执行，确定立即结束吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      });
    },
    handleQuestionDetail(data) {
      this.showQuestionDetail = true;
      let params = {
        alarmId: data.alarmId,
      };
      this.$fetch(api.videoTask.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.questionDetail = response.returnObj;
          this.questionDetail.reportTime = data.reportTime;
        } else {
          this.$message.error(response.msgContent || "获取巡逻问题详情失败");
        }
      });
    },
    handleClosePanel() {
      this.showDetail = false;
    },
    //  openWarning(warningId) {
    //   // for (let i = 0; i < warningId.videoPatrolAlarm.length; i++) {
    //   //   this.warnList.push(warningId.videoPatrolAlarm[i].alarmId);
    //   // }
    //   this.$fetch(api.videoTask.historyAlarm, {
    //     alarmId: this.warnList[0],
    //   }).then((res) => {
    //     this.alarmContent = res.returnObj;
    //   });
    //   this.warnVisible = true;
    // },
    handleCloseQuestionP() {
      this.close();
    },
    confirm() {
      this.showRightPanel = false;
    },
    cancel() {
      this.showRightPanel = false;
      this.formData = {};
    },
    closeRight() {
      this.showRightPanel = false;
    },
    close() {
      this.showQuestionDetail = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-main {
  padding: 12px;
  height: 100%;
  position: relative;
}
.question-title,
.base-title {
  border-left: 4px solid #4386ff;
  padding-left: 16px;
}

.base-body {
  margin-bottom: 12px;
  .base-table {
    display: flex;
    flex-direction: column;
    padding: 15px 5px;
  }
}

.base-table_row {
  display: flex;
  padding-bottom: 25px;

  // flex-direction: column;
  .col-content {
    flex: 1;
    display: inline-flex;

    .col-label {
      width: 100px;
      // background: #4b5566;
      text-align: center;
      padding: 2px 10px;
      border-radius: 3px;
    }

    .col-value {
      width: 200px;
      // background: #4b5566;
      text-align: left;
      padding: 2px 10px;
      border-radius: 3px;

      img,
      video {
        width: 150px;
        height: 150px;
        border-radius: 5px;
      }
    }
  }
}
</style>